import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikansk fotboll",
    Baseball: "Baseboll",
    Basketball: "Basket",
    Boxing: "Boxning",
    Chess: "Schack",
    Cricket: "Cricket",
    Darts: "Dart",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Fotboll",
    "Formula 1": "Formel 1",
    "Gaelic Football": "Gaelisk fotboll",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Handboll",
    "Ice Hockey": "Ishockey",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Bordtennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} för att vinna",
    WinFirstRound: "{name} för att vinna första omgången",
    FirstTouchdown: "{name} för att göra mål en touchdown första",
    FirstTry: "{name} för att göra ett försök först",
    TotalGoals: "{name} Totala mål",
    TotalRuns: "{name} Totala runs",
    TotalPoints: "{name} Poängtotal",
    TopBatsman: "{name} att vara Top slagman",
    TopBowler: "{name} att vara Top Bowler",
    FirstScore: "{name} för att göra mål först"
  },
  PromoTexts: {
    Pick: "Gör dina val",
    Bet: "Bet",
    Pays: "Utbetalning"
  },
  DateTimeTexts: {
    Today: "I dag",
    Tomorrow: "I morgon",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Gör dina val",
    Return: "Utbetalning",
    Stake: "Bet",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Gjorda mål",
    shots: "Skott",
    shots_on_target: "Skott på mål",
    ball_possession: "Bollinnehav",
    goals_conceded: "Insläppta mål",
    "Per match": "Per match",
    H2H: "H2H",
    W: "V",
    D: "O",
    L: "F",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing",
    rushing_yards_per_game: "Yards",
    rushing_touchdowns: "Touchdowns",
    rushing_percentage: "%",
    passing_stats: "Passing",
    passing_yards_per_game: "Yards",
    passing_touchdowns: "Touchdowns",
    passing_percentage: "%"
  }
};
